import { render } from "./RadioAnswer.vue?vue&type=template&id=3cc2091e"
import script from "./RadioAnswer.vue?vue&type=script&lang=js"
export * from "./RadioAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__